import { render, staticRenderFns } from "./TagsEditar.vue?vue&type=template&id=1416e526"
import script from "./TagsEditar.vue?vue&type=script&lang=js"
export * from "./TagsEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports